export default [
  {
    path: '/app/donation-groups/incomes',
    name: 'DonationIncomesGroups',
    component: () => import('@/views/Admin/Donation_groups/Incomes/Index.vue'),
    meta: {
      pageTitle: 'Gelir Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
  {
    path: '/app/donation-groups/incomes/add',
    name: 'DonationIncomesGroupAdd',
    component: () => import('@/views/Admin/Donation_groups/Incomes/Add.vue'),
    meta: {
      pageTitle: 'Gelir Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/donation-groups/incomes',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
  {
    path: '/app/donation-groups/incomes/edit/:id',
    name: 'DonationIncomesGroupEdit',
    component: () => import('@/views/Admin/Donation_groups/Incomes/Edit.vue'),
    meta: {
      pageTitle: 'Gelir Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/donation-groups/incomes',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
  {
    path: '/app/donation-groups/expenses',
    name: 'DonationExpensesGroups',
    component: () => import('@/views/Admin/Donation_groups/Expenses/Index.vue'),
    meta: {
      pageTitle: 'Gider Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
  {
    path: '/app/donation-groups/expenses/add',
    name: 'DonationExpensesGroupAdd',
    component: () => import('@/views/Admin/Donation_groups/Expenses/Add.vue'),
    meta: {
      pageTitle: 'Gider Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/donation-groups/expenses',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
  {
    path: '/app/donation-groups/expenses/edit/:id',
    name: 'DonationExpensesGroupEdit',
    component: () => import('@/views/Admin/Donation_groups/Expenses/Edit.vue'),
    meta: {
      pageTitle: 'Gider Grupları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/app/donation-groups/expenses',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DONATION_GROUPS',
      action: 'read',
    },
  },
]
